const brushMixin = {

  data() {
    return {
      brushState: false,
      refineFlag: true, //是否已经细化了
    }
  },
  methods: {
    custombrush() {
      return {
        mybrush: {
          show: true,
          type: ["lineX"],
          title: {
            lineX: this.translateText("textMap.",'放大'),
          },
          iconStyle: {
            borderColor: this.brushState ?'#74ACC8' : null
          },
          icon: {
            lineX: "M13.5,7c0,3.7-2.9,6.5-6.5,6.5S0.5,10.6,0.5,7c0-3.7,2.9-6.5,6.5-6.5S13.5,3.3,13.5,7z M7,9.6V4.4 M9.6,7H4.4"
          },
          onclick: () => {
            this.brushState = !this.brushState;
            let option = {
              toolbox: {
                feature: {
                  mybrush: {
                    iconStyle: {
                      borderColor: this.brushState ? '#74ACC8' : null
                    }
                  }
                }
              }
            }
            this.mychart.setOption(option)
            this.mychart.dispatchAction({
              type: "takeGlobalCursor",
              key: "brush",
              brushOption: {
                brushType: this.brushState ? "lineX" : false,
              },
            });
          }
        }};
    },
    getMyBrushRestore() {
      return{
        myBrushRestore: {
          show: true,
          title: this.translateText("textMap.","放大还原"),
          icon: "M7,0.5c3.6,0,6.5,2.9,6.5,6.5s-2.9,6.5-6.5,6.5S0.5,10.6,0.5,7S3.4,0.5,7,0.5z M9.6,7H4.4",
          onclick:  () =>{
            if(this.refineFlag){
              this.$emit("cancelRefine");
            }
          },
        }
      }
    },
    getMyUseNowTime() {
      return {
        myUseNowTime: {
          title: this.translateText("textMap.", "使用当前时间"),
          icon: this.useBruchTime.icon,
          show: true,
          iconStyle: {
            borderColor: null
          },
          onclick: () => {
            if(this.$store.state.globalTimeTrend != '起止时间' || this.$store.state.globalTimeBegin != this.$store.state.nowTrendStartTime || this.$store.state.globalTimeEnd != this.$store.state.nowTrendEndTime){
              this.$store.state.globalTimeTrend = '起止时间'
              this.$store.state.globalTimeBegin = this.$store.state.nowTrendStartTime
              this.$store.state.globalTimeEnd = this.$store.state.nowTrendEndTime
            }
          }
        },
      }
    },
  }
}

export default brushMixin



// WEBPACK FOOTER //
// ./src/mixins/brushMixin.js